import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { PhoneLink } from "@/components/site/PhoneLink";

export default function Footer() {
  return (
    <footer className="bg-[#0A0D0B] border-t border-[#233027] pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img src="/scales.png" alt="" aria-hidden="true" className="h-11 w-auto" />
              <div className="font-display text-4xl tracking-tight text-[#F5F3EC]">
                Grafton<span className="text-[#B89874]">.</span>
              </div>
            </div>
            <p className="mt-4 text-[#A3ACA6] max-w-sm leading-relaxed">
              Credit Recovery, Document Serving & Debt Management specialists across New Zealand.
            </p>
            <p className="mt-6 text-[10px] uppercase tracking-[0.28em] text-[#B89874]">
              {BRAND.credibility}
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] uppercase tracking-[0.24em] text-[#A3ACA6] mb-5">Navigate</h4>
            <ul className="space-y-3 text-[#F5F3EC]">
              <li><a href="#services" className="hover:text-[#B89874] transition-colors">Services</a></li>
              <li><a href="#process" className="hover:text-[#B89874] transition-colors">Our Process</a></li>
              <li><a href="#about" className="hover:text-[#B89874] transition-colors">About</a></li>
              <li><Link to="/documents" className="hover:text-[#B89874] transition-colors">Document Centre</Link></li>
              <li><Link to="/schedule" className="hover:text-[#B89874] transition-colors" data-testid="footer-schedule-link">Schedule of Charges</Link></li>
              <li><Link to="/terms" className="hover:text-[#B89874] transition-colors" data-testid="footer-terms-link">Terms of Engagement</Link></li>
              <li><Link to="/portal" className="hover:text-[#B89874] transition-colors" data-testid="footer-portal-link">Document Retrieval</Link></li>
              <li><Link to="/client" className="hover:text-[#B89874] transition-colors" data-testid="footer-client-link">Client Login</Link></li>
              <li><Link to="/admin/login" className="hover:text-[#B89874] transition-colors" data-testid="footer-admin-link">Admin Login</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-[11px] uppercase tracking-[0.24em] text-[#A3ACA6] mb-5">Contact</h4>
            <ul className="space-y-4 text-[#F5F3EC]">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#B89874] mt-1" />
                <PhoneLink className="hover:text-[#B89874] transition-colors">{BRAND.phone}</PhoneLink>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#B89874] mt-1" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-[#B89874] transition-colors break-all">{BRAND.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#B89874] mt-1" />
                <span className="text-[#A3ACA6]">{BRAND.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#233027] flex flex-col md:flex-row justify-between gap-4 text-[#58635C] text-xs">
          <span>© {new Date().getFullYear()} {BRAND.legal}. All rights reserved.</span>
          <span className="font-mono-gg">{BRAND.bank}</span>
        </div>
      </div>
    </footer>
  );
}
